import type { I18nDict } from '../types.ts'

export const es: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Ajustes',
  section_language: 'Idioma',
  section_identity: 'Identidad local',
  section_updates: 'Actualización de la app',
  section_notifications: 'Notificaciones',
  section_theme: 'Tema visual',
  section_backup: 'Copia de seguridad del chat',
  section_privacy_network: 'Privacidad de red',
  section_media: 'Multimedia',
  section_security: 'Seguridad y contraseña',
  section_exit: 'Cerrar y destruir datos',
  toggle_external_links: 'Recibir y ver enlaces externos',
  hint_external_links: 'Si está DESACTIVADO: no hay vistas previas de enlaces en el chat y no se pueden abrir URL externas (protección contra rastreo por IP).',
  toggle_auto_media: 'Descarga automática de multimedia y documentos',
  hint_auto_media: 'Si está DESACTIVADO: las fotos, vídeos y archivos no se descargan en segundo plano — tócalos manualmente en el chat.',
  toggle_require_unlock: 'Contraseña al abrir la app',
  hint_require_unlock: 'Cuando está ACTIVADO, se requiere la contraseña maestra cada vez que abres ZION.',
  toggle_wipe_exit: 'Borrar datos al salir',
  hint_wipe_exit: 'Cuando está ACTIVADO, al cerrar la app se borra la caché temporal en RAM y los datos de sesión.',
  btn_exit: 'Salir',
  btn_delete_all: 'ELIMINAR TODOS LOS DATOS',
  btn_lock: 'Bloquear app',
  btn_back: 'Atrás',
  warn_disable_password_title: '⚠️ ADVERTENCIA',
  warn_disable_password_body: 'Desactivar la contraseña de apertura significa que cualquiera con tu dispositivo puede leer tus mensajes cifrados. ¿Seguro que quieres continuar?',
  warn_delete_all_1: '¿Realmente quieres destruir toda la base de datos? Esta acción es irreversible.',
  warn_delete_all_2: 'Confirmación final: todos los chats, claves privadas y ajustes se eliminarán permanentemente.',
  link_blocked: 'Enlace externo bloqueado (ajustes de privacidad).',
  lang_welcome_title: 'Bienvenido a ZION',
  lang_welcome_sub: 'Elige tu idioma',
  lang_continue: 'Continuar',
  settings_language_label: 'Idioma de la app',
  auth_unlock_title: 'Desbloquear',
  auth_or_password: '— o desbloquear con contraseña —',
  auth_password_master: 'Contraseña maestra',
  auth_unlock_btn: 'Desbloquear',
  auth_verifying: 'Verificando…',
  auth_wrong_password: 'Contraseña incorrecta',
  auth_unlocked: 'Desbloqueado ✓',
  auth_access_title: 'Unirse a ZION',
  auth_beta_spots: 'Beta gratuita · plazas restantes:',
  auth_beta_full: 'Beta completa ({max} usuarios). Inténtalo más tarde.',
  auth_beta_free: 'Beta gratuita · no se requiere licencia',
  auth_or_create: '— o crear una nueva identidad —',
  auth_password_min: 'Contraseña (mín. 8 caracteres)',
  auth_password_confirm: 'Confirmar contraseña',
  auth_privacy_check: 'He leído la',
  auth_privacy_link: 'Política de privacidad',
  auth_terms_check: 'Acepto los',
  auth_terms_link: 'Términos del servicio',
  auth_password_local_hint: 'La contraseña nunca sale de este dispositivo. Sin cuenta en servidor.',
  auth_create_identity: 'Crear identidad',
  auth_accept_legal_err: 'Acepta la Política de privacidad y los Términos para continuar',
  auth_generating_keys: 'Generando claves y sesión…',
  auth_generating_identity: 'Generando identidad anónima…',
  auth_generating_detail: 'Claves ECDH · apodo · sesión socket · código ZN-',
  auth_you_are: 'Eres',
  auth_daily_suffix_hint: 'El sufijo diario cambia cada día UTC. Para emparejar, usa el código ZN- en Inicio.',
  auth_enter: 'Entrar en ZION',
  auth_starting: 'Iniciando…',
  auth_restore_title: 'Restaurar copia de seguridad',
  auth_restore_hint: '¿Ya tienes una copia cifrada? Recupera identidad, contactos y chats (p. ej., tras borrar la caché).',
  auth_restore_file: 'Archivo de copia (.enc / .enc.json)',
  auth_restore_pass: 'Frase de contraseña de la copia',
  auth_restore_pass_ph: 'Frase usada al exportar',
  auth_restore_btn: 'Restaurar copia de seguridad',
  auth_restore_pick_file: 'Selecciona un archivo de copia (.enc o .enc.json).',
  auth_restore_need_pass: 'Introduce la frase de contraseña.',
  auth_restoring: 'Restaurando…',
  auth_file_prefix: 'Archivo:',
  common_accept: 'Aceptar',
  common_reject: 'Rechazar',
  common_cancel: 'Cancelar',
  common_accepting: 'Aceptando…',
  common_error: 'Error',
  common_loading: 'Cargando…',
  common_send: 'Enviar',
  common_copied: 'Copiado ✓',
  common_copy_failed: 'Error al copiar',
  common_ok: 'OK',
  common_today: 'Hoy',
  common_yesterday: 'Ayer',
  common_sending: 'Enviando…',
  home_zn_midnight_hint: 'Cambia a medianoche UTC (en {h}h {m}m)',
  home_temp_empty: 'No hay chats temporizados. Toca ⏱ en un contacto para iniciar uno.',
  home_unread_aria: '{count} mensajes',
  home_temp_waiting: 'Esperando aceptación…',
  home_temp_expires: 'Chat temporizado · expira en {remaining}',
  home_temp_cancel: 'Cancelar',
  home_temp_fallback_label: 'chat temporizado',
  home_temp_invite_title: '⏱ Invitación a chat temporizado',
  home_temp_invite_body: '{nick} quiere un chat efímero ({duration}).',
  home_temp_invite_hint: 'Acepta para empezar a intercambiar mensajes que desaparecerán al expirar.',
  home_temp_accept: 'Aceptar',
  home_temp_reject: 'Rechazar',
  home_temp_accepting: 'Aceptando…',
  home_contacts_empty: 'No hay contactos. Comparte tu código ZN- o QR para emparejar.',
  home_temp_chat_aria: 'Chat temporizado',
  home_btn_pair_title: 'Emparejar',
  home_btn_settings_title: 'Ajustes',
  home_zn_title: 'Código ZN- de hoy',
  home_btn_copy_zn: 'Copiar ZN-',
  home_btn_open_pair: 'QR de emparejamiento',
  home_section_temp: 'Chats temporizados',
  home_section_chat: 'Chats',
  home_loading: 'Cargando…',
  home_pair_zn_title: 'Emparejar con código ZN-',
  home_btn_zn_pair: 'Enviar solicitud',
  home_copied: 'Copiado ✓',
  home_copy_failed: 'Error al copiar',
  home_pair_request_title: 'Solicitud de contacto',
  home_pair_request_body: '{name} quiere chatear.',
  home_pair_reject: 'Rechazar',
  home_pair_accept: 'Aceptar',
  home_pair_accepting: 'Aceptando…',
  home_pair_accept_failed: 'Error al aceptar',
  home_zn_digits_err: 'Introduce los 5 dígitos después de ZN-.',
  home_sending: 'Enviando…',
  chat_rename: 'Renombrar',
  chat_rename_matrix: '[RENOMBRAR]',
  chat_rename_title: 'Renombrar contacto',
  chat_menu_title: 'Opciones del chat',
  chat_loading: 'Cargando mensajes…',
  chat_reply_to: 'Responder a',
  chat_cancel_title: 'Cancelar',
  chat_voice_lock_hint: 'Desliza hacia arriba para bloquear la grabación',
  chat_voice_locked: 'Grabación bloqueada — toca Hecho',
  chat_voice_stop: 'HECHO',
  chat_voice_stop_title: 'Hecho',
  chat_voice_preview_label: 'Vista previa de voz — escucha antes de enviar',
  chat_voice_send: 'ENVIAR',
  chat_voice_send_title: 'Enviar',
  chat_timer_label: 'Temporizador',
  chat_timer_title: 'Temporizador de mensaje',
  chat_timer_off: 'OFF',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Mantén pulsado para grabar',
  chat_voice_hold_title: 'Mantén pulsado para grabar',
  chat_doc: 'Doc',
  chat_doc_title: 'Documento',
  chat_attach_title: 'Adjuntos',
  chat_input_placeholder: 'Mensaje cifrado E2E…',
  chat_send: 'Enviar',
  chat_rename_modal_title: 'Renombrar contacto',
  chat_rename_nickname: 'Apodo: @{nick}',
  chat_rename_placeholder: 'Nombre personalizado',
  chat_rename_cancel: 'Cancelar',
  chat_rename_save: 'Guardar',
  chat_action_reply: '↩ Responder',
  chat_action_copy: '⎘ Copiar',
  chat_action_delete_me: '🗑 Eliminar para mí',
  chat_action_delete_all: '🗑 Eliminar para todos',
  chat_action_cancel: 'Cancelar',
  chat_menu_clear_me: '🗑 Vaciar chat (solo para mí)',
  chat_menu_clear_all: '🗑 Eliminar chat para todos',
  chat_menu_cancel: 'Cancelar',
  chat_doc_send_title: 'Enviar documento',
  chat_doc_default_name: 'documento',
  chat_doc_send_hint: 'El archivo se comprimirá, cifrará E2E y se enviará. Máx. 5 MB.',
  chat_doc_cancel: 'Cancelar',
  chat_doc_send_encrypted: 'Enviar cifrado',
  chat_doc_too_large: '⚠️ ARCHIVO DEMASIADO GRANDE: El límite de seguridad máximo para documentos es 5 MB.',
  chat_doc_unsupported: 'Tipo de documento no compatible.',
  chat_copy_failed: 'Error al copiar',
  chat_confirm_delete_me: '¿Eliminar este mensaje solo para ti?',
  chat_confirm_delete_all: '¿Eliminar este mensaje para todos?',
  chat_confirm_clear_all: '¿Eliminar todo el chat para todos? Esta acción es irreversible.',
  chat_confirm_clear_me: '¿Vaciar el chat solo para ti?',
  chat_jump_new: '↓ Mensajes nuevos',
  chat_empty: 'No hay mensajes. Escribe algo para empezar.',
  chat_voice_err_short: 'Mensaje de voz demasiado corto (mínimo 1 segundo).',
  chat_voice_err_long: 'Mensaje de voz demasiado largo (máximo 2 minutos).',
  chat_voice_err_large: 'Mensaje de voz demasiado grande (máx. 3 MB).',
  chat_voice_err_start: 'No se pudo iniciar la grabación de voz.',
  chat_destroyed: '✉ Mensaje leído y destruido',
  chat_destroyed_title: 'Mensaje leído y destruido',
  chat_hold_options: 'Mantén pulsado para opciones',
  chat_reply_fallback: 'Mensaje',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'El código ZN- cambia a medianoche UTC (en {h}h {m}m).',
  pair_copied: 'Copiado ✓',
  pair_copy_failed: 'Error al copiar',
  pair_title: 'Emparejamiento',
  pair_zn_title: 'Tu código ZN- de hoy',
  pair_btn_copy_zn: 'Copiar código ZN-',
  pair_tab_mine: 'Mi QR',
  pair_tab_scan: 'Escanear / ZN-',
  pair_qr_aria: 'QR de emparejamiento',
  pair_expires_in: 'Expira en',
  pair_btn_copy_payload: 'Copiar payload',
  pair_btn_regen_qr: 'Regenerar QR',
  pair_qr_hint: 'Muestra este QR al otro dispositivo. Válido 10 minutos — compatible con la app Android.',
  pair_expired: 'expirado',
  pair_contact_zn_title: 'Código ZN- del contacto',
  pair_zn_prefix_hint: 'El prefijo <strong>ZN-</strong> ya está establecido — introduce solo las 5 letras/dígitos.',
  pair_btn_zn_request: 'Enviar solicitud ZN-',
  pair_paste_title: 'O pega un QR ZION1::',
  pair_paste_hint: 'Pega un payload <code>ZION1::</code> o sube una foto del QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Desde foto / cámara',
  pair_btn_connect_qr: 'Conectar con QR',
  pair_zn_digits_err: 'Introduce los 5 dígitos después de ZN-.',
  pair_sending: 'Enviando solicitud…',
  pair_reading_qr: 'Leyendo QR…',
  pair_qr_not_found: 'Código QR no encontrado en la imagen.',
  pair_zn_read_ok: 'Código ZN- leído — confirma con Enviar solicitud.',
  pair_qr_read_ok: 'QR leído — confirma con Conectar con QR.',
  pair_qr_read_err: 'Error al leer el QR.',
  settings_identity_hint: 'La contraseña y las claves permanecen en este navegador. Sin cuenta en servidor.',
  settings_btn_add_home: 'Guía Añadir a Inicio',
  settings_devices_title: 'Dispositivos vinculados',
  settings_devices_hint: 'Multi-dispositivo Zero-Knowledge: las claves viajan cifradas E2E. El servidor solo actúa como relé.',
  settings_btn_link_device: 'Vincular nuevo dispositivo',
  settings_btn_sync_pc: 'Sincronizar historial del PC',
  settings_no_devices: 'No hay dispositivos vinculados.',
  settings_device_self: 'este dispositivo',
  settings_version_prefix: 'Versión:',
  settings_ios_push_hint: '<strong>iPhone:</strong> notificaciones = PWA desde Inicio + Banner/Sonido ACTIVADO. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Forzar actualización de la app',
  settings_updating: 'Actualizando…',
  settings_push_mode_prefix: 'Modo:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> las notificaciones solo funcionan al abrir ZION desde el icono de la pantalla de inicio (Compartir → Añadir a pantalla de inicio). En Safari normal <em>no</em> están disponibles — incluso en iOS 17. Tras instalar en Inicio, vuelve aquí y toca Activar notificaciones.',
  settings_btn_enable_push: 'Activar notificaciones push',
  settings_btn_desktop_notify: 'Notificaciones de escritorio (PC)',
  settings_btn_disable_push: 'Desactivar notificaciones',
  settings_desktop_requesting: 'Solicitando permiso de escritorio…',
  settings_desktop_ok: 'Notificaciones de escritorio activas (sonido + ventana emergente al recibir un mensaje).',
  settings_desktop_denied: 'Permiso denegado o no compatible.',
  settings_push_no_session: 'Sesión no lista.',
  settings_push_requesting: 'Solicitando permiso…',
  settings_push_active: 'Notificaciones activas.',
  settings_push_disabled: 'Notificaciones desactivadas.',
  settings_theme_hint: 'Los mismos temas que la app ZION para Android.',
  settings_theme_recommended: 'Recomendado',
  settings_backup_hint: 'Archivo JSON cifrado con una frase de contraseña (compatible con formato Android v2). Guárdalo en tu PC: contactos, chats e identidad web.',
  settings_backup_pass_label: 'Frase de contraseña de la copia',
  settings_backup_pass_ph: 'Frase dedicada (mín. 8 caracteres)',
  settings_btn_export_backup: 'Exportar copia de seguridad',
  settings_backup_file_label: 'Restaurar desde archivo',
  settings_backup_import_pass_label: 'Frase de contraseña de la copia',
  settings_backup_import_pass_ph: 'Frase usada al exportar',
  settings_btn_import_backup: 'Restaurar copia de seguridad',
  settings_backup_file_prefix: 'Archivo: {name}',
  settings_backup_pass_min: 'La frase de contraseña debe tener al menos 8 caracteres.',
  settings_backup_creating: 'Creando copia de seguridad…',
  settings_backup_pick_file: 'Selecciona un archivo de copia (.enc o .enc.json).',
  settings_backup_need_pass: 'Introduce la frase de contraseña de la copia.',
  settings_backup_restoring: 'Restaurando…',
  settings_backup_overwrite_confirm: '¿Sobrescribir datos locales?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minutos',
  temp_duration_10m: '10 minutos',
  temp_duration_15m: '15 minutos',
  temp_duration_30m: '30 minutos',
  temp_duration_1h: '1 hora',
  temp_duration_6h: '6 horas',
  temp_duration_24h: '24 horas',
  temp_duration_7d: '7 días',
  temp_remaining_expired: 'Expirado',
  temp_remaining_days: '{days}d {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Chat temporizado · mensajes efímeros',
  temp_empty: 'No hay mensajes efímeros.',
  temp_empty_hint: 'Escribe un mensaje efímero. Desaparecerá cuando expire el temporizador.',
  temp_input_placeholder: 'Mensaje efímero…',
  temp_send: 'Enviar',
  temp_waiting_accept: 'Esperando a que {name} acepte el chat temporizado…',
  temp_waiting_placeholder: 'Esperando aceptación…',
  temp_expires_in: 'Expira en {remaining}',
  temp_duration_title: 'Chat temporizado',
  temp_duration_with: 'Con {name}',
  temp_duration_hint: 'Elige la duración — el chat desaparecerá de ambos dispositivos.',
  temp_sending_invite: 'Enviando invitación…',
  voice_lock_hint: 'Desliza hacia arriba para bloquear la grabación',
  voice_locked: 'Grabación bloqueada — toca Hecho',
  add_home_title: 'Añadir a pantalla de inicio (iPhone / iPad)',
  add_home_guide_title: 'Guía de Safari',
  add_home_step1: 'Abre <strong>Safari</strong> en esta página (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Toca <strong>Compartir</strong> (cuadrado con flecha hacia arriba)',
  add_home_step3: 'Elige <strong>Añadir a pantalla de inicio</strong>',
  add_home_step4: 'Abre ZION desde el <strong>icono</strong> — no desde una pestaña de Safari',
  add_home_hint: 'En iOS/iPadOS 16.4+ la app de pantalla de inicio admite notificaciones Web Push y el teclado del chat. Tras instalar, ve a <strong>Ajustes → Activar notificaciones</strong>.',
  add_home_btn_continue: 'Entendido — continuar',
  add_home_btn_skip: 'Omitir por ahora',
  search_title: 'Buscar con código ZN-',
  search_label: 'Código ZN- diario',
  search_placeholder: 'ZN-123456',
  search_btn: 'Buscar',
  search_hint: 'Introduce el código ZN- del contacto. Sin búsqueda por apodo — la identidad es solo local.',
  search_format_err: 'Formato: ZN-123456',
  search_resolving: 'Resolviendo código…',
  search_invalid_code: 'Código no válido — pide un ZN- actualizado (reabre ZION en el dispositivo de la otra persona)',
  search_session_found: 'sesión encontrada',
  search_tap_to_send: 'Toca para enviar solicitud',
  search_socket_not_ready: 'Sesión socket no lista',
  search_request_sent: 'Solicitud enviada ✓',
  search_request_failed: 'Error al enviar',
  license_title: 'Activación de licencia Web / iPhone',
  license_heading: 'Licencia',
  license_heading_updated: 'Términos actualizados',
  license_hint: 'Introduce el código <strong>ZION-XXXX-XXXX-XXXX</strong> adquirido en zionyx.ch. Se vinculará a este navegador (clave local).',
  license_code_label: 'Código de licencia',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Activar licencia',
  license_beta_hint: 'Beta web: usa una licencia dedicada para iPhone si está disponible.',
  license_accept_legal_err: 'Acepta la Política de privacidad y los Términos para continuar',
  license_need_code: 'Introduce el código de licencia',
  license_verifying: 'Verificando licencia…',
  license_invalid_or_used: 'Licencia no válida o ya usada en otro dispositivo',
  license_active: 'Licencia activa ✓',
  license_err_not_found: 'Código de licencia no válido',
  license_err_conflict: 'Licencia ya vinculada a otro dispositivo',
  license_err_rate_limit: 'Demasiados intentos — espera un minuto',
  license_err_generic: 'Error de licencia',
  link_device_title: 'Vincular nuevo dispositivo',
  link_device_hint: 'En tu <strong>PC</strong>, abre Ajustes → Vincular nuevo dispositivo: verás el <strong>QR verde</strong>. Luego escanéalo abajo (cámara o foto).',
  link_device_status_ready: '[LISTO]',
  link_device_upload_label: 'Subir foto del QR',
  link_device_btn_camera: 'Abrir cámara / galería',
  link_device_placeholder: 'Enlace QR o payload…',
  link_device_btn_send_vault: 'Enviar bóveda cifrada',
  link_device_err_invalid_qr: 'QR no válido o expirado.',
  link_device_status_invalid: '[QR NO VÁLIDO]',
  link_device_status_sync_complete: '[SINCRONIZACIÓN COMPLETA]',
  link_device_status_transfer_failed: '[TRANSFERENCIA FALLIDA]',
  link_device_status_qr_detected: '[QR DETECTADO — TRANSFIRIENDO...]',
  link_device_status_tap_camera: '[TOCA EL BOTÓN VERDE — CÁMARA IPHONE]',
  link_device_status_use_camera_below: '[USA CÁMARA / GALERÍA ABAJO]',
  link_device_status_point_camera: '[APUNTA LA CÁMARA AL QR DEL PC...]',
  link_device_status_decoding: '[DECODIFICANDO QR...]',
  link_device_status_qr_not_found: '[QR NO ENCONTRADO]',
  link_device_status_decode_failed: '[DECODIFICACIÓN FALLIDA]',
  link_device_status_opened_from_qr: '[ABIERTO DESDE QR — INICIANDO...]',
  link_recv_title: 'Vincular desde el teléfono',
  link_recv_hint_compact:
    'Escanea este <strong>QR verde</strong> con el teléfono (Ajustes → Vincular nuevo dispositivo). El vault viaja cifrado de extremo a extremo.',
  link_recv_hint_auth:
    '¿Ya tienes ZION en el teléfono? Escanea este QR con la <strong>Cámara</strong> — el PC se vincula e inicia sesión automáticamente.',
  link_recv_qr_alt: 'QR de vinculación de dispositivo',
  link_recv_copy_link: 'Copiar enlace',
  link_recv_awaiting: '[ESPERANDO ESCANEO DEL TELÉFONO — TÚNEL ABIERTO...]',
  link_recv_failed: '[VINCULACIÓN FALLIDA]',
  link_recv_tunnel_lost:
    'Túnel interrumpido — el vault podría seguir en tránsito. Vuelve a escanear el QR.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nuevo mensaje cifrado',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Mensaje efímero',
  force_update_title: '🚨 ACTUALIZACIÓN CRÍTICA OBLIGATORIA — Para seguir usando Zionyx de forma segura, debes descargar la última versión.',
  force_update_desc: 'El cliente instalado no es compatible con la versión mínima activa en el servidor.',
  force_update_versions: 'Instalada: v{current} · Requerida: v{required}',
  force_update_btn: 'ACTUALIZAR AHORA',
}
